import Bullet from "../../../public/homePage/icons/bullet.svg";

const RightArrow = () => {
  return (
    <>
      {/* <Image
        src={`data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAABHNCSVQICAgIfAhkiAAAA2ZJREFUSEutls1OE1EUx8902iYWE3BLCGmUtdQnsKwIX5G+wfAEtGpigKhFHkCiG8GFRfe2pCUkbBhW4kLpG9AuSDCRODUh1n7M+D+TmcmdYehcEm/SdObec87vno+55yoUMfb29jKWZX2AWEYQ1fHcwE/vdru7uVzOiLLD64qMULVazS4sLDDAHvyuKArDs6qq5mdmZhgcOa7AyuXySHCn8GwElibxawIiZTiM7IMhZBoMF+fn59MID+96Ge9ZKDJMHHYIsVaJx+O74gJsbGLego1CEOjBnNzo2Hl2eno6g3/Ok8xo8AYB3WFhjkwikdDxeALgkmjAg9VqtToAm7Ozs7ppmqcyFFEGQB2RWOIwMzCZTFYwdyoCbRgSvhiLxfJzc3PZfr+/ianlm8IceQN2pgCsux5yOtwa8DxzCwOwulMMA3nm2RmZPy8oPnk/KOcBr82ZuwCYJePV5bMVMs/PKfV8jdSJiaBKHSF98N9gvW/f6c+bt6Qkk5Raf0mx0dGg7XUAi6EFwpNIaAbFcSLjGct09SNqf/xEyu0hGtp4RcrwsKhqAHbHB0MV5lExXBTEyUSCD2VhLPf3c5k61Rqp8CxVfEGUSHjq2HwOn0QFjApsawoe+AO0C0WEtbe27QKQGeaPc7Jav0kdH6fUxrqosgPvNHzD/DkVfTA+ljD5i6UvC0/IvJCDsby9W84fvIuNjdlA2DuCZ9lQGAt41djvyzhF3eOv1N5+T0o8TrdWV0i9d1cMow1zDgxNcanuqQ4Ytwtfpq+jdr8cU/vdVijI0WkijGk3VQzTOp1Oxf3Ke70en48Po9ySABHs7KLgFl1bV1oMPMtj8XUU7PLxUzINg1Jrq77QBfQK8MyudC+vogCSmpY5iLl4LKM1CNSCV2l453Xx0E4NGJ/Yj6K8G7QO/SUUR0mU8R3EXDkoFAaxd3wgSxVKEMqg/f39BucLnYTT4g8jFtN84sNtbjUlFIp2gwbq2mtik9rBwYEB4CH0p2CLN301Z0K3toF8VnJ/i6jOFixVAClxh3YuQ2XoFNhGaBjdSQfIoSwhpEWed6B8VUi7cjCuI+wGN0p3zmmYdchr4m3s2mrkBVbif9n7oLj7sNvZQFhYlTm7LgfWmjjEtTD5sDmpS6rrLcIm3ooJ7w3ZCyrb+AetaNZJhCHCbwAAAABJRU5ErkJggg==`}
        alt=""
        width={22}
        height={22}
        className="right-arrow-icon"
      /> */}
      <Bullet className="right-arrow-icon" />
      {/* <div className="right-arrow-icon"></div> */}
    </>
  );
};

export default RightArrow;
